<template>
  <div>
    <section>
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Depots</h1>
          </v-col>
        </v-row>

        <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col cols="12" sm="12" md="3">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="1" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn text large @click="updateDataTable" v-on="on">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="12" md="2" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="newDepot" class="mx-2" fab dark color="blue lighten-1" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new depot</span>
            </v-tooltip>
          </v-col>

        </v-row>
      </v-container>
      <v-divider></v-divider>

      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedDepots"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers"
                :key="index">{{props.item[header.value]}}
            </td>
            <td v-else class="text-center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon @click="editRow(props.item)" color="blue" v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon @click="deleteRow(props.item)" color="red" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </section>

    <v-dialog
      v-model="depotDialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <h3>{{editedIndex > -1 ? 'Edit depot ' + depotItem.id : 'New depot'}}</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="depotItem.name"
            label="Depot name"
            prepend-icon="fa fa-store-alt"
          ></v-text-field>
          <v-select
            label="Choose a region"
            :items="regions"
            item-text="name"
            item-value="id"
            v-model="depotItem.region_id"
            prepend-icon="fas fa-map-marked-alt"
          ></v-select>
          <v-text-field
            v-model="depotItem.address"
            label="Address"
            prepend-icon="fas fa-map-marker-alt"
          ></v-text-field>
          <v-text-field
            v-model="depotItem.address2"
            label="Address 2"
            prepend-icon="fas fa-map-marker-alt"
          ></v-text-field>
          <v-text-field
            v-model="depotItem.suburb"
            label="Suburb"
            prepend-icon="fas fa-map-marker-alt"
          ></v-text-field>
          <v-text-field
            v-model="depotItem.state"
            label="State"
            prepend-icon="fas fa-map-marker-alt"
          ></v-text-field>
          <v-text-field
            v-model="depotItem.postcode"
            label="Postcode"
            prepend-icon="fas fa-map-marker-alt"
          ></v-text-field>
          <v-text-field
            v-model="depotItem.active_phone_cap"
            label="Phone Cap"
            prepend-icon="fas fa-phone"
            type="number"
          ></v-text-field>
          <v-text-field
            v-model="depotItem.depot_code"
            label="Depot Code"
            prepend-icon="fas fa-map-marker-alt"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            text
            @click="closeDepotDialog"
            color="blue-grey lighten-2"
          >Cancel
          </v-btn>
          <v-btn
            text
            @click="saveChanges"
            color="blue darken-1"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this depot. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="deleteDepot" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "ManageDepots",
        data() {
            return {
                search: '',
                loading: false,
                reload: false,
                timer: '',
                headers: [
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    {text: 'Name', value: 'name', align: 'center', sortable: true},
                    {text: 'Code', value: 'code', align: 'center', sortable: true},
                    {text: 'Region name', value: 'region_name', align: 'center', sortable: true},
                    {text: 'Address', value: 'address', align: 'center', sortable: true},
                    {text: 'Suburb', value: 'suburb', align: 'center', sortable: true},
                    {text: 'State', value: 'state', align: 'center', sortable: true},
                    {text: 'WMS ?', value: 'wms', align: 'center', sortable: true},
                    {text: 'Phone Cap', value: 'active_phone_cap', align: 'center', sortable: true},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ],
                depotDialog: false,
                editedIndex: -1,
                toBeDeleted: null,
                deleteDialog: false,
                regions: [],
                depotItem: {
                    region_id: null,
                    name: null,
                    address: null,
                    address2: null,
                    suburb: null,
                    state: null,
                    postcode: null,
                    depot_code:null
                },
                default: {
                    region_id: null,
                    name: null,
                    address: null,
                    address2: null,
                    suburb: null,
                    state: null,
                    postcode: null,
                    depot_code:null
                },

            }
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.reload = !this.reload;
            }, 300000)
            this.getRegions();
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            renderedDepots() {
                if (this.Depots === null || this.Depots === undefined) {
                    return [];
                } else {
                    return this.Depots;
                }
            },
        },
        asyncComputed: {
            async Depots() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/depots')
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            return [];
                        });
                }
            }
        },
        methods: {
            updateDataTable() {
                this.reload = !this.reload;
            },
            newDepot() {
                this.editedIndex = -1;
                this.depotItem = Object.assign({}, this.default);
                this.depotDialog = true;
            },
            editRow(item) {
                this.editedIndex = this.Depots.indexOf(item);
                this.depotItem = Object.assign({}, item);
                this.depotDialog = true;
            },
            closeDepotDialog() {
                this.depotDialog = false;
                this.editedIndex = -1;
            },
            // @vuese
            // Gets all the regions.
            getRegions() {
                axios.get(process.env.API_URL + '/regions')
                    .then((response) => {
                        this.regions = response.data;
                    })
                    .catch((response) => {
                         this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            saveChanges() {
                let body = this.depotItem;

                if (this.editedIndex > -1) {
                    axios.put(process.env.API_URL + '/depots/' + this.depotItem.id, body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', "Changes saved");
                            this.updateDataTable();
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    if (body.name === null) {
                        this.$store.commit('displaySnackbar', 'Please select a name for the region');
                        return false;
                    }

                    axios.post(process.env.API_URL + '/depots', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Create successful');
                            this.updateDataTable();
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Create failed');
                        })
                }
                this.closeDepotDialog();
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            deleteDepot() {
                let index = this.Depots.indexOf(this.toBeDeleted);
                axios.delete(process.env.API_URL + '/depots/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.$emit('displaySnackbar', 'Detete successful');
                        this.Depots.splice(index, 1);
                        this.deleteDialog = false;
                        this.updateDataTable();
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/GlobalAdmin/ManageDepots.vue